const PERMISSION_KEY= "core:tenant_invitation";
const PAGE_URL = {
    TENANT_INVITATION_PAGE: "/admin/core/tenant-invitation"
}

export {PERMISSION_KEY, PAGE_URL}

